import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import { BottomSheet } from "@componentsShared/BottomSheet";
import useTranslation from "@/i18n/useTranslation";
// @ts-ignore — PNG imports lack type declarations (pre-existing project pattern)
import couponsImg from "../OilProductCard/assets/Coupons.png";
// ── Social icon SVGs ──────────────────────────────────────────────────────────

var WhatsAppCircleIcon = function WhatsAppCircleIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "clip-path": "url(#clip0_1045_14880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#62B958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5818 13.4183C32.0848 10.8964 28.7688 9.34976 25.2319 9.05743C21.695 8.7651 18.1701 9.7463 15.2929 11.824C12.4158 13.9018 10.3758 16.9393 9.54095 20.3886C8.7061 23.838 9.13136 27.4721 10.74 30.6356L9.16092 38.3019C9.14454 38.3782 9.14407 38.4571 9.15956 38.5336C9.17504 38.6101 9.20615 38.6825 9.25092 38.7465C9.31651 38.8435 9.41014 38.9182 9.5193 38.9606C9.62846 39.003 9.74795 39.011 9.86183 38.9837L17.3755 37.2028C20.53 38.7708 24.1385 39.1687 27.5589 38.3258C30.9793 37.4828 33.9897 35.4538 36.0544 32.5996C38.1192 29.7455 39.1044 26.2514 38.8348 22.739C38.5651 19.2266 37.0581 15.9238 34.5818 13.4183ZM32.2391 32.1165C30.5114 33.8393 28.2867 34.9765 25.8785 35.368C23.4702 35.7594 20.9998 35.3852 18.8155 34.2983L17.7682 33.7801L13.1618 34.871L13.1755 34.8137L14.13 30.1774L13.6173 29.1656C12.5012 26.9736 12.1075 24.4846 12.4925 22.0551C12.8776 19.6257 14.0217 17.3804 15.7609 15.641C17.9463 13.4563 20.9099 12.229 24 12.229C27.0901 12.229 30.0537 13.4563 32.2391 15.641C32.2577 15.6624 32.2778 15.6824 32.2991 15.701C34.4574 17.8913 35.6623 20.8461 35.651 23.9211C35.6398 26.9961 34.4133 29.942 32.2391 32.1165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8301 28.7154C31.2655 29.6045 30.3737 30.6927 29.2528 30.9627C27.2892 31.4372 24.2755 30.979 20.5255 27.4827L20.4792 27.4418C17.1819 24.3845 16.3255 21.84 16.5328 19.8218C16.6473 18.6763 17.6019 17.64 18.4064 16.9636C18.5336 16.855 18.6845 16.7777 18.8469 16.7379C19.0093 16.6981 19.1788 16.6968 19.3418 16.7341C19.5047 16.7715 19.6567 16.8465 19.7856 16.9531C19.9144 17.0597 20.0165 17.195 20.0837 17.3481L21.2973 20.0754C21.3762 20.2522 21.4054 20.4472 21.3819 20.6394C21.3583 20.8316 21.2829 21.0137 21.1637 21.1663L20.5501 21.9627C20.4184 22.1271 20.3389 22.3272 20.3219 22.5372C20.3049 22.7471 20.3511 22.9574 20.4546 23.1409C20.7982 23.7436 21.6219 24.63 22.5355 25.4509C23.561 26.3781 24.6982 27.2263 25.4182 27.5154C25.6109 27.5941 25.8227 27.6133 26.0264 27.5705C26.2301 27.5278 26.4163 27.425 26.561 27.2754L27.2728 26.5581C27.4101 26.4227 27.5809 26.3261 27.7678 26.2782C27.9546 26.2303 28.1509 26.2328 28.3364 26.2854L31.2192 27.1036C31.3782 27.1524 31.5239 27.2369 31.6453 27.3506C31.7666 27.4644 31.8604 27.6044 31.9193 27.7599C31.9783 27.9154 32.0009 28.0824 31.9854 28.248C31.9699 28.4136 31.9168 28.5735 31.8301 28.7154Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1045_14880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "48",
    height: "48",
    fill: "white"
  }))));
};
var XCircleIcon = function XCircleIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "clip-path": "url(#clip0_1050_455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7456 0 0 10.7456 0 24C0 37.2544 10.7456 48 24 48C37.2544 48 48 37.2544 48 24C48 10.7456 37.2544 0 24 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6259 21.8281L36.9 9.88525H34.4654L25.5444 20.2551L18.4192 9.88525H10.2012L20.9758 25.5662L10.2012 38.0901H12.6359L22.0568 27.1392L29.5815 38.0901H37.7995L26.6253 21.8281H26.6259ZM13.5132 11.7181H17.2529L34.4665 36.3406H30.7269L13.5132 11.7181Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "48",
    height: "48",
    fill: "white"
  }))));
};
var FacebookCircleIcon = function FacebookCircleIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 35.9794 39.2231 45.9084 27.75 47.7084V30.9375H33.3422L34.4062 24H27.75V19.4981C27.75 17.5997 28.68 15.75 31.6613 15.75H34.6875V9.84375C34.6875 9.84375 31.9406 9.375 29.3147 9.375C23.8331 9.375 20.25 12.6975 20.25 18.7125V24H14.1562V30.9375H20.25V47.7084C8.77688 45.9084 0 35.9794 0 24C0 10.7456 10.7456 0 24 0C37.2544 0 48 10.7456 48 24Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3422 30.9375L34.4062 24H27.75V19.498C27.75 17.6001 28.6798 15.75 31.6612 15.75H34.6875V9.84375C34.6875 9.84375 31.941 9.375 29.3152 9.375C23.833 9.375 20.25 12.6975 20.25 18.7125V24H14.1562V30.9375H20.25V47.7083C21.4719 47.9001 22.7242 48 24 48C25.2758 48 26.5281 47.9001 27.75 47.7083V30.9375H33.3422Z",
    fill: "white"
  }));
};

// ── Share content (body only — title + X handled by BottomSheet) ──────────────

var ShareContent = function ShareContent(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    image = _ref.image,
    url = _ref.url,
    copied = _ref.copied,
    onCopy = _ref.onCopy;
  var _useTranslation = useTranslation(["web_oils"]),
    tShort = _useTranslation.tShort;
  var effectiveImage = image || couponsImg;
  var encodedUrl = encodeURIComponent(url);
  var shareText = encodeURIComponent(subtitle ? "".concat(title, " - ").concat(subtitle) : title);
  var socials = [{
    label: tShort("share_modal/whatsapp", {
      ns: "web_oils"
    }),
    href: "https://wa.me/?text=".concat(shareText, "%20").concat(encodedUrl),
    icon: /*#__PURE__*/React.createElement(WhatsAppCircleIcon, null)
  }, {
    label: tShort("share_modal/twitter", {
      ns: "web_oils"
    }),
    href: "https://twitter.com/intent/tweet?url=".concat(encodedUrl, "&text=").concat(shareText),
    icon: /*#__PURE__*/React.createElement(XCircleIcon, null)
  }, {
    label: tShort("share_modal/facebook", {
      ns: "web_oils"
    }),
    href: "https://www.facebook.com/sharer.php?u=".concat(encodedUrl),
    icon: /*#__PURE__*/React.createElement(FacebookCircleIcon, null)
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "px-1 pb-4 md:w-[65%] md:mx-auto md:pb-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center  border border-solid border-[#E1E8F2] rounded-lg m-4 px-4 mb-8"
  }, /*#__PURE__*/React.createElement("img", {
    src: effectiveImage,
    alt: title,
    className: "w-24 h-24 object-contain rounded-lg flex-shrink-0"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-sm font-bold text-[#1B2035] flex-1 leading-snug px-5"
  }, title, subtitle ? /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", subtitle) : null)), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center gap-8 mb-8"
  }, socials.map(function (s) {
    return /*#__PURE__*/React.createElement("a", {
      key: s.label,
      href: s.href,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "flex flex-col items-center gap-2 no-underline"
    }, s.icon, /*#__PURE__*/React.createElement("span", {
      className: "text-sm text-[#1B2035] font-medium"
    }, s.label));
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 px-4"
  }, /*#__PURE__*/React.createElement("input", {
    id: "oil-share-url-input",
    type: "text",
    readOnly: true,
    value: url,
    dir: "ltr",
    className: "flex-1 border border-solid border-[#E1E8F2]  rounded-xl px-3 py-3 text-sm text-[#5A6880] outline-none truncate min-w-0"
  }), /*#__PURE__*/React.createElement("button", {
    onClick: onCopy,
    className: "bg-primary-new text-white font-bold rounded-lg border-none px-5 py-3 text-sm whitespace-nowrap flex-shrink-0  transition-colors"
  }, copied ? "\u2713 ".concat(tShort("share_modal/copied", {
    ns: "web_oils"
  })) : tShort("share_modal/copy_link", {
    ns: "web_oils"
  }))));
};

// ── Main component ────────────────────────────────────────────────────────────

var OilShareModal = function OilShareModal(_ref2) {
  var isOpen = _ref2.isOpen,
    onClose = _ref2.onClose,
    title = _ref2.title,
    subtitle = _ref2.subtitle,
    image = _ref2.image;
  var _useTranslation2 = useTranslation(["web_oils"]),
    tShort = _useTranslation2.tShort;
  var _useState = useState(false),
    copied = _useState[0],
    setCopied = _useState[1];
  var _useState2 = useState(""),
    url = _useState2[0],
    setUrl = _useState2[1];
  useEffect(function () {
    if (typeof window !== "undefined") {
      setUrl(window.location.href);
    }
  }, []);
  var handleCopy = function handleCopy() {
    var fallback = function fallback() {
      var input = document.getElementById("oil-share-url-input");
      if (input) {
        input.select();
        document.execCommand("copy");
        setCopied(true);
        setTimeout(function () {
          return setCopied(false);
        }, 3000);
      }
    };
    if (typeof navigator !== "undefined" && navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        setCopied(true);
        setTimeout(function () {
          return setCopied(false);
        }, 3000);
      })["catch"](fallback);
    } else {
      fallback();
    }
  };
  return /*#__PURE__*/React.createElement(BottomSheet, {
    open: isOpen,
    onOpen: function onOpen() {},
    onClose: onClose,
    haveClose: true,
    hideTitleBar: true,
    customClassName: "oil-modal",
    modalDesign: {
      closeAnimation: false
    },
    maxWidthDesktop: "880px",
    screens: [{
      title: tShort("share_modal/title", {
        ns: "web_oils"
      }),
      component: /*#__PURE__*/React.createElement(ShareContent, {
        title: title,
        subtitle: subtitle,
        image: image,
        url: url,
        copied: copied,
        onCopy: handleCopy
      })
    }]
  });
};
export default OilShareModal;